/**
 * Tracks the last method the user logged in with, so the login page can show a
 * "Last used" badge next to email vs. Google. Ported from the Ember login
 * (`LoginService.lastLoginMethod`), same `localStorage` key.
 */
export const LoginMethod = {
  Email: 'email',
  Google: 'google',
} as const;

export type LoginMethod = (typeof LoginMethod)[keyof typeof LoginMethod];

const LAST_LOGIN_METHOD_STORAGE_KEY = 'last-login-method';

export function getLastLoginMethod(): LoginMethod | null {
  const stored = localStorage.getItem(LAST_LOGIN_METHOD_STORAGE_KEY);
  if (stored === LoginMethod.Email || stored === LoginMethod.Google) {
    return stored;
  }
  return null;
}

export function setLastLoginMethod(method: LoginMethod): void {
  localStorage.setItem(LAST_LOGIN_METHOD_STORAGE_KEY, method);
}
